export function stringIncludes(haystack, needle, caseSensitive = false) {
  haystack = (haystack || '').toString();
  needle = (needle || '').toString();
  if (!caseSensitive) {
    haystack = haystack.toLowerCase();
    needle = needle.toLowerCase();
  }
  return haystack.includes(needle);
}
export function widthInPixels(str) {
  let width;
  let node = document.createTextNode(str);
  let ruler = document.createElement('span');
  ruler.style.height = '0';
  ruler.style.visibility = 'hidden';
  ruler.style.whiteSpace = 'nowrap';
  ruler.style.position = 'absolute';
  ruler.appendChild(node);
  document.body.appendChild(ruler);
  width = ruler.offsetWidth;
  document.body.removeChild(ruler);
  return width;
}